import styled, { css } from 'styled-components/macro'
import { darken } from 'polished'

export const LabelTitle = styled.label`
  margin: 0 0 0.8rem;
  width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.textThird};
`

export const Amount = styled.span`
  white-space: nowrap;
`

export const Box = styled.div`
  margin: 0;
  padding: 0 1.8rem 1.8rem 1.8rem;
  width: 100%;
  max-width: 56.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 0.1rem solid ${(props) => props.theme.color.elementBorder};
  border-radius: 0.8rem;
  overflow: hidden;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 0 1.8rem 0 0;
    display: grid;
    grid-template-columns: 1fr 14.4rem;
  `};
`

export const Label = styled.label`
  padding: 1.2rem 0;
  padding: 2.2rem 0 2.2rem 1.8rem;
  display: grid;
  grid-template-columns: 2rem 1fr;
  align-items: center;
  gap: 1.2rem;
  cursor: pointer;
  a {
    color: ${(props) => props.theme.color.textHint};
    &:hover {
      color: ${(props) => darken(0.1, props.theme.color.textHint)};
    }
  }
`

export const ButtonWrap = styled.div<{ isWrapped?: boolean }>`
  margin: 0;
  width: 100%;
  max-width: 44rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
  ${(props) =>
    props.isWrapped &&
    css`
      max-width: 60.2rem;
    `}
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    ${
      props.isWrapped &&
      css`
        grid-template-columns: ${props.isWrapped ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'};
      `
    }
  `};
`

export const TableWrap = styled.div`
  margin: 0 0 3.2rem;
  width: 100%;
`
